import React from 'react';
import { List } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  faChartColumn,
  faHouse,
  faMessageSmile,
  faUserSecret,
} from '@fortawesome/pro-light-svg-icons';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import NavItem from './NavItem';

function DevNav({ isOpen, isMobile, onImpersonateClick, onSignOut, onNavigate }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isImpersonating = useSelector((state) => state.impersonation.isImpersonating);
  const canImpersonate = useSelector((state) => state.user.user?.canImpersonate === true);

  const handleClick = (action) => () => {
    action();
    if (isMobile && onNavigate) onNavigate();
  };

  const navItems = [
    {
      title: 'Home',
      icon: faHouse,
      isActive: pathname === '/',
      onClick: handleClick(() => navigate('/')),
    },
    ...(canImpersonate
      ? [
          {
            title: 'Impersonate',
            icon: faUserSecret,
            isActive: isImpersonating,
            onClick: onImpersonateClick,
          },
        ]
      : []),
    {
      title: 'Analytics',
      icon: faChartColumn,
      isActive: pathname === '/analytics',
      onClick: handleClick(() => navigate('/analytics')),
    },
    {
      title: 'Feedback',
      icon: faMessageSmile,
      isActive: pathname === '/feedback',
      onClick: handleClick(() => navigate('/feedback')),
    },
    {
      title: 'Sign out',
      icon: faArrowRightFromBracket,
      isActive: false,
      onClick: onSignOut,
    },
  ];

  return (
    <nav className={'mss__devNavList ' + (isOpen ? 'opened' : 'closed')}>
      <List sx={{ pt: 0 }}>
        {navItems.map(({ title, icon, isActive, onClick }) => (
          <NavItem
            key={title}
            title={title}
            icon={icon}
            isOpen={isOpen}
            isActive={isActive}
            onClick={onClick}
          />
        ))}
      </List>
    </nav>
  );
}

export default DevNav;
